import type { MouseEvent } from 'react';
import logo from '@/assets/img/logo-light.svg';
import type { MenuItem } from '@/types/app';

interface FooterProps {
  siteName: string;
  items: MenuItem[];
}

const DIDOMI_HREF = '#preferences-publicitaires';

function handleItemClick(item: MenuItem, event: MouseEvent<HTMLAnchorElement>) {
  if (item.url !== DIDOMI_HREF) return;
  event.preventDefault();
  const didomi = (window as unknown as { Didomi?: { preferences?: { show?: () => void } } }).Didomi;
  didomi?.preferences?.show?.();
}

export function Footer({ siteName, items }: FooterProps) {
  return (
    <footer className="footer">
      <div className="footer__container">
        <div className="footer__logo">
            <img src={logo} alt={siteName} width={147} height={34} />
            <p>© {new Date().getFullYear()} - tous droits réservés - Lemon</p>
        </div>
        <div className="footer__legals">
            <ul>
              {items.map((item) => (
                <li key={item.id}>
                  <a
                    href={item.url}
                    target={item.target || undefined}
                    onClick={(event) => handleItemClick(item, event)}
                  >
                    {item.title}
                  </a>
                </li>
              ))}
            </ul>
        </div>
      </div>
    </footer>
  );
}
